module.exports = __webpack_public_path__ + "static/fonts/Roboto-Medium.b2bcaa5.ttf";


//////////////////
// WEBPACK FOOTER
// ./src/components/assets/fonts/Roboto-Medium/Roboto-Medium.ttf
// module id = nKGE
// module chunks = 17